<template>
    <on-click-outside :do="close">
        <div class="relative" :class="{'is-active': showDelete}">
            <div ref="button" class="p-1 cursor-pointer" @click.prevent="switchPopper">
                <font-awesome-icon
                        :icon="['fas', 'ellipsis-v']"
                        class="text-menu-inactive-gray-light my-auto ml-2"
                ></font-awesome-icon>
            </div>
            <div ref="panel" v-if="showDelete" class="absolute rounded-lg flex flex-col bg-white shadow-md z-50">
                <div>
                    <div v-if="!newPlace" @click.prevent="disInput" class="flex flex-row hover:bg-red hover:text-white p-2 rounded-t-lg cursor-pointer">
                        <font-awesome-icon
                                :icon="['far', 'pen-alt']"
                                class=" my-auto cursor-pointer mx-2"
                        ></font-awesome-icon>
                        <p>Редактировать</p>
                    </div>
                    <div class="flex flex-row hover:bg-red hover:text-white p-2 rounded-b-lg cursor-pointer" @click.prevent="switchPopperConfirm">
                        <font-awesome-icon
                                :icon="['far', 'trash-alt']"
                                class=" my-auto cursor-pointer mx-2"
                        ></font-awesome-icon>
                        <p>Удалить</p>
                    </div>
                </div>
            </div>
            <confirm-delete :showDeleteConfirm="showDeleteConfirm" @deletePlace="$emit('deletePlace')" @close="showDeleteConfirm = false" v-if="showDeleteConfirm"></confirm-delete>
        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../../OnClickOutside';
import ConfirmDelete from './confirm-delete';

export default {
  name: 'delete-place',
  props: ['newPlace'],
  components: { ConfirmDelete, OnClickOutside },

  data() {
    return {
      showDelete: false,
      showDeleteConfirm: false,
    };
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  },
  methods: {
    disInput() {
      this.$emit('disableInput');
      this.close();
    },
    switchPopper() {
      this.showDelete = !this.showDelete;
      this.showDeleteConfirm = false;
      if (this.showDelete) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    switchPopperConfirm() {
      this.showDeleteConfirm = !this.showDeleteConfirm;
      this.showDelete = !this.showDelete;
    },
    setupPopper() {
      this.popper = undefined;
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.panel, {
          placement: 'bottom',
          positionFixed: false,
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    close() {
      if (!this.showDelete) {
        return;
      }
      this.showDelete = false;
    },
  },
};
</script>

<style scoped lang="less">
    .button-class{
        color: white;
        border-radius: 1rem;
    }
</style>
